module.exports = __webpack_public_path__ + "static/img/lengcang.fe137fc1.svg";